import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import Snackbar from "@material-ui/core/Snackbar";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import AlertDialog from "../Prompt/alert-dialog.component";
import { withRouter } from "react-router-dom";
import {
  GetProvinces,
  GetCityByProvinceId,
  DeleteCityBrandGroup,
  GetCityBrandsByid,
  AddCityBrands,
  EditCityBrands,
  GetBrands,
  GetGoodsType,
} from "../../fetchs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
});
var firstProvinceId="";

class User extends Component {
  constructor(props) {
    super(props);

    this.state = {
      flag: false,
      province: [],
      provinceId: null,
      name: "",
      family: "",
      tell: "",
      address: "",
      email: "",
      businessCode: "",
      cityId: null,
      userTypeId: null,
      permission: false,
      agent: false,
      cities: [],
      userTypes: [],
      loading: true,
      saving: false,
      openSnackbar: false,
      errorMessage: "",
      introducerCode: "",
      brands: [],
      BrandId: "",
      isAvailable: false,
      goodsTypeId: null,
      goodTypes: [],
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    if (this.props.match.params.id) {
      GetCityBrandsByid(this.props.match.params.id)
        .then((response) => {
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
          else{
            this.setState({
             provinceId: responseJson.city.provinceId,
              cityId: responseJson.cityId,
              BrandId: responseJson.brandId,
              isAvailable: responseJson.isAvailable,
              goodsTypeId: responseJson.goodsTypeId,
            });
            firstProvinceId = responseJson.city.provinceId;
              this.getCitiesByProvince();
          }
        })
        .catch((error) => {
          toast.error(error.message);
          console.error(error);
        });

 }

 // دریافت همه استان ها
    GetProvinces(0, 50)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ province: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });


// دریافت همه برند ها
    GetBrands(0, 500)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
            
          });
        else
          this.setState({
            brands: responseJson.data,
          }
        );
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });


      // گرفتن همه نوع کالا
    GetGoodsType(0, 999)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else
          this.setState({
            goodTypes: responseJson.data,
          });

      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  }



  handleChangeProvince = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      this.getCitiesByProvince();
    });
  };

  //دریافت شهر بر اساس استان
  getCitiesByProvince = () => {
    if(this.state.provinceId != null){
      firstProvinceId = this.state.provinceId;
    }   GetCityByProvinceId(firstProvinceId) //firstProvinceId :  (چون آی دی استان اول در زمان ویرایش نال میداد)به جای استفاده از  کال بک ازین متغیر استفاده شده

    .then((response) => {
      return response.json();
    })
    .then((responseJson) => {
      if (responseJson.Message)
        this.setState({
          errorMessage: responseJson.Message,
          openSnackbar: true,
        });
      else this.setState({ cities: responseJson });
    })
    .catch((error) => {
      console.error(error);
    });
  
};


  handleSave = () => {
    if (this.props.match.params.id) {
      EditCityBrands({
        goodsTypeId: this.state.goodsTypeId,
        cityId: this.state.cityId,
        brandId: this.state.BrandId,
        isAvailable: this.state.isAvailable,
        id: this.props.match.params.id,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error(" !ویرایش برند در شهر با خطا مواجه شد ");
          } else if (response.status === 200) {
            toast.success(" .برند در شهر با موفقیت ویرایش شد ");

            this.props.history.push(`/main/cityBrands/${this.state.cityId}`);
          }
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      AddCityBrands({
        goodsTypeId: this.state.goodsTypeId,
        cityId: this.state.cityId,
        provinceId: this.state.provinceId,
        BrandId: this.state.BrandId,
        isAvailable: this.state.isAvailable,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error(" افزودن برند در شهر با خطا مواجه شد");
            console.log(response);
          } else if (response.status === 200) {
            toast.success("برند در شهر با موفقیت اضافه شد");

            this.props.history.push(`/main/cityBrands/${this.state.cityId}`);
          }
          return response.json();
        })
        .then((responseJson) => {
          if (responseJson.Message)
            this.setState({
              errorMessage: responseJson.Message,
              openSnackbar: true,
            });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  handleCheckChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  //edit p

  handleDelete = () => {
    this.setState({ alertDialog: false, loading: true });
    DeleteCityBrandGroup({
      goodsTypeId: this.state.goodsTypeId,
      cityId: this.state.cityId,
      provinceId: this.state.provinceId,
      BrandId: this.state.BrandId,})
      .then((response) => {
        this.setState({ loading: false });
        if (response.status === 200)
          toast.success("برندها در شهرها با موفقیت حذف شدند");
        else toast.error("خطای حذف برندها در شهرها");

      })

      .catch((error) => {
        console.log(error);
      });
  };

  handlePrepareDelete = () => {
    this.setState({ alertDialog: true });
  };
  handleCloseDialog = () => {
    this.setState({ alertDialog: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            {this.props.match.params.id ? (
              <Typography component='h1' variant='h4' align='center'>
                ویرایش برند در شهر
              </Typography>
            ) : (
              <Typography component='h1' variant='h4' align='center'>
                افزودن برند در شهر جدید
              </Typography>
            )}
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete='off'>
                <Grid container spacing={3}>
                  <Grid item lg={3}>
                    <TextField
                      id='standard-select-city'
                      select
                      label='استان'
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.provinceId}
                      onChange={this.handleChangeProvince("provinceId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin='normal'
                    >
                      {this.state.province.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name} - {option.province}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item lg={3}>
                    <TextField
                      id='standard-select-city'
                      select
                      label='شهر'
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.cityId}
                      onChange={this.handleChange("cityId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin='normal'
                    >
                      {this.state.cities.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name} - {option.province}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item lg={3}>
                    <TextField
                      id='BrandId'
                      name='BrandId'
                      select
                      fullWidth
                      label='برند'
                      className={classes.textField}
                      value={this.state.BrandId}
                      onChange={this.handleChange("BrandId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin='normal'
                    >
                      {this.state.brands.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item lg={3}>
                    <TextField
                      id='goodsTypeId'
                      name='goodsTypeId'
                      select
                      fullWidth
                      label='نوع محصول'
                      className={classes.textField}
                      value={this.state.goodsTypeId}
                      onChange={this.handleChange("goodsTypeId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin='normal'
                    >
                      {this.state.goodTypes.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.isAvailable}
                        onChange={this.handleCheckChange("isAvailable")}
                        value='permission'
                        color='primary'
                      />
                    }
                    label='فعال/غیرفعال'
                  />

                  <Grid item xs={12}>
                    <Button
                      variant='contained'
                      color='primary'
                      disabled={this.state.loading}
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>

                    <Button
                      variant='contained'
                      color='inherit'
                      disabled={this.state.loading}
                      onClick={
                        this.handlePrepareDelete}
                    >
                       حذف
                    </Button>

                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>

          <AlertDialog
          open={this.state.alertDialog}
          title={`هشدار`}
          body={`آیا از حذف گروهی برندها در شهرها اطمینان دارید؟`}
          handleYes={this.handleDelete}
          handleNo={this.handleCloseDialog}
        />


          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id='message-id'> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

User.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(User));
